import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { assertNotNull } from '@core/prelude';
import { ClaimsService } from '@core/authentication/claims.service';
import { Claims } from '@core/authentication/claims';
import { EntityType } from '@features/contacts/models';
import { ContactEventService, ContactInfo } from '@features/contacts/services/contact-event.service';
import { SidebarSubMenuItem } from '@shared/components/menu/sidebar-sub-menu/sub-menu.model';

@Component({
  selector: 'spark-contacts-company-layout',
  templateUrl: './company-layout.component.html',
  styleUrls: ['./company-layout.component.scss']
})
export class CompanyLayoutComponent implements OnInit, OnDestroy {
  routePrefix = ['/Contacts', 'Company'];
  items: SidebarSubMenuItem[][] = [];

  companyId$ = this.route.paramMap.pipe(
    map((params) => params.get('companyId')),
    tap((x) => this.contactEventService.updateContactId(EntityType.Company, x)),
    tap((x) => {
      this.contactEventService.updateContactId(EntityType.Company, x);

      if (x) {
        this.routePrefix = ['/Contacts', 'Company', x];
      }
    }),
    assertNotNull(
      'Internal error: <app-company-layout> expects companyId parameter in route'
    )
  );
  
  // Use resolved data from route resolver
  companySummary$ = this.route.data.pipe(
    map(data => data['company'])
  );

  constructor(
    private route: ActivatedRoute,
    private contactEventService: ContactEventService,
    private claimsService: ClaimsService
  ) {}

  ngOnInit(): void {
    this.setupMenuItems();
  }

  ngOnDestroy() {
    this.contactEventService.updateContactId(EntityType.Company, null);
    this.contactEventService.resetContactInfo();
  }

  private setupMenuItems(): void {
    const baseMenuItems: SidebarSubMenuItem[] = [
      {
        label: 'Summary',
        link: []
      },
      {
        label: 'Notes',
        link: ['Notes']
      },
      {
        label: 'Opportunities',
        link: ['Opportunities']
      },
      {
        label: 'Products',
        link: ['Products']
      },
      {
        label: 'Tasks',
        link: ['Tasks']
      }
    ];

    // Only show Audit menu item for Network Administrators
    if (this.claimsService.userRole === Claims.UserRoles.NetworkAdministrator) {
      baseMenuItems.push({
        label: 'Audit',
        link: ['Audit']
      });
    }

    this.items = [baseMenuItems];
  }
}
